import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { CheckCircle2, ArrowRight } from "lucide-react";
import api from "@/lib/api";
import { CtaStrip, AvailabilityForm } from "@/components/sections/HomeSections";
import SEO, { serviceSchema } from "@/components/SEO";

export default function ServiceDetail() {
  const { slug } = useParams();
  const [svc, setSvc] = useState(null);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    api.get(`/services/${slug}`)
      .then(r => setSvc(r.data))
      .catch(() => setNotFound(true));
  }, [slug]);

  if (notFound) return <div className="pt-40 text-center">Service not found.</div>;
  if (!svc) return <div className="pt-40 text-center text-white/40">Loading…</div>;

  const features = svc.features || [];
  return (
    <div data-testid="service-detail" className="pt-24">
      <SEO title={svc.name} path={`/services/${slug}`} description={svc.tagline} image={svc.image}
           jsonLd={serviceSchema(svc.name, svc.tagline)} />
      <section className="relative h-[60vh] overflow-hidden">
        <img src={svc.image} alt={svc.name} className="absolute inset-0 w-full h-full object-cover" />
        <div className="absolute inset-0 cine-overlay" />
        <div className="relative h-full max-w-[1400px] mx-auto px-6 md:px-10 flex flex-col justify-end pb-16">
          <div className="eyebrow">What We Do</div>
          <h1 className="font-serif text-5xl md:text-7xl font-light mt-3 tracking-tight">{svc.name}</h1>
          <p className="text-white/70 max-w-2xl mt-3">{svc.tagline}</p>
        </div>
      </section>
      <section className="section-pad max-w-[1400px] mx-auto grid lg:grid-cols-2 gap-16 items-start">
        <div>
          <div className="eyebrow">What's Included</div>
          <h2 className="font-serif text-4xl mt-3">Built Around <em className="text-[#D4AF37] not-italic">Your Story</em></h2>
          <ul className="mt-8 space-y-3">
            {features.map((f, i) => (
              <li key={i} className="flex gap-3 text-white/80"><CheckCircle2 size={18} className="text-[#D4AF37] mt-1 shrink-0"/>{f}</li>
            ))}
          </ul>
          <Link to="/contact" className="btn-gold mt-10 inline-flex">Say Hello <ArrowRight size={14}/></Link>
        </div>
        <img src={svc.image} alt="" className="w-full h-[600px] object-cover" />
      </section>
      <AvailabilityForm id="service-availability" />
      <CtaStrip />
    </div>
  );
}
